module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-05713a43.png";